import { Context, UserContext } from './types';

export const createContext = (routeId: string = 'starting'): Context => {
  let activeRoute = routeId;
  let user: UserContext = {
    id: '',
    role: '',
    name: '',
    roleImpersonated: '',
  };

  return {
    getUser: () => user,
    hasUser: () => user.id !== '',

    getUserId: () => user.id,
    getRole: () => user.role,
    getName: () => user.name,
    setUser: (newUser: UserContext) => {
      user = newUser;
    },

    setActiveRouteId: (routeId: string) => {
      activeRoute = routeId;
    },
    getActiveRouteId: () => activeRoute,
    isActiveRoute: (routeId: string) => activeRoute === routeId,
  };
};
